import { NavBar } from 'Modules/NavBar';

export const Footer = () => {
  return (
    <div>
      <NavBar location="footer" />
    </div>
  );
};